<template>
    <div>
        <v-autocomplete
            v-model="autocomplete.vModel"
            :items="autocomplete.items"
            :loading="autocomplete.isLoading"
            :search-input.sync="autocomplete.search"
            :error-messages="fieldErrors"
            :class="{ 'error--text': fieldErrors.length }"
            item-text="name"
            item-value="id"
            label="Denumire"
            data-vv-as="Denumire"
            placeholder="Tastati denumirea sau un CUI"
            return-object
            no-filter
        >
            <template v-slot:append-outer>
                <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="primary"
                    @click="dialog = true"
                >
                    <v-icon dark>
                        mdi-plus
                    </v-icon>
                </v-btn>
            </template>
        </v-autocomplete>

        <template v-if="expandeable">
            <v-text-field
                v-model="autocomplete.vModel.vat_no"
                :disabled="true"
                class="primary--text"
                name="vat_no"
                label="CUI / CNP"
                data-vv-as="CUI / CNP"
                data-vv-name="vat_no"
            />
            <v-btn block color="primary" class="my-3" @click="expand = !expand">{{ !expand ? 'Mai multe' : 'Mai putin' }}</v-btn>
            <v-expand-transition v-if="expand">
                <div class="transition-fast-in-fast-out v-card--reveal">
                    <v-text-field
                        v-model="autocomplete.vModel.trade_registry_no"
                        :disabled="true"
                        class="primary--text"
                        name="trade_registry_no"
                        label="Numarul Registrul Comertului"
                        data-vv-as="Numarul Registrul Comertului"
                        data-vv-name="trade_registry_no"
                    />
                    <v-text-field
                        v-model="autocomplete.vModel.bank"
                        :disabled="true"
                        class="primary--text"
                        name="bank"
                        label="Banca"
                        data-vv-as="Banca"
                        data-vv-name="bank"
                    />
                    <v-text-field
                        v-model="autocomplete.vModel.iban"
                        :disabled="true"
                        class="primary--text"
                        name="iban"
                        label="IBAN"
                        data-vv-as="IBAN"
                        data-vv-name="iban"
                    />
                    <v-divider
                        class="mx-4"
                        vertical
                    ></v-divider>
                    <v-subheader>
                        Sediu social
                    </v-subheader>

                    <v-text-field
                        v-model="autocomplete.vModel.country"
                        :disabled="true"
                        class="primary--text"
                        name="country"
                        label="Tara"
                        data-vv-as="Tara"
                        data-vv-name="country"
                    />

                    <v-text-field
                        v-model="autocomplete.vModel.county"
                        :disabled="true"
                        class="primary--text"
                        name="county"
                        label="Judet"
                        data-vv-as="Judet"
                        data-vv-name="county"
                    />

                    <v-text-field
                        v-model="autocomplete.vModel.city"
                        :disabled="true"
                        class="primary--text"
                        name="city"
                        label="Localitate"
                        data-vv-as="Localitate"
                        data-vv-name="city"
                    />
                    <v-text-field
                        v-model="autocomplete.vModel.address"
                        :disabled="true"
                        class="primary--text"
                        name="address"
                        label="Strada"
                        data-vv-as="Strada"
                        data-vv-name="address"
                    />

                    <v-divider
                        class="mx-4"
                        vertical
                    ></v-divider>
                    <v-subheader>
                        Alte informatii
                    </v-subheader>
                    <v-text-field
                        v-model="autocomplete.vModel.phone"
                        :disabled="true"
                        class="primary--text"
                        name="phone"
                        label="Telefon"
                        data-vv-as="Telefon"
                        data-vv-name="phone"
                    />
                    <v-text-field
                        v-model="autocomplete.vModel.email"
                        :disabled="true"
                        class="primary--text"
                        name="email"
                        label="E-mail"
                        data-vv-as="E-mail"
                        data-vv-name="email"
                    />
                    <v-text-field
                        v-model="autocomplete.vModel.data.contact_person"
                        :disabled="true"
                        class="primary--text"
                        name="data.contact_person"
                        label="Persoana de contact"
                        data-vv-as="Persoana de contact"
                        data-vv-name="data.contact_person"
                    />
                    <v-text-field
                        v-model="autocomplete.vModel.data.due_days"
                        :disabled="true"
                        class="primary--text"
                        name="data.due_days"
                        label="Zile scadenta"
                        data-vv-as="Zile scadenta"
                        data-vv-name="data.due_days"
                    />
                    <v-textarea
                        v-model="autocomplete.vModel.data.remarks"
                        :disabled="true"
                        class="primary--text"
                        name="remarks"
                        label="Observatii"
                        data-vv-as="Observatii"
                        data-vv-name="remarks"
                    />
                </div>
            </v-expand-transition>
        </template>
        <template v-if="!inline && !expandeable">
            <v-text-field
                v-model="autocomplete.vModel.vat_no"
                :disabled="true"
                class="primary--text"
                name="vat_no"
                label="CUI / CNP"
                data-vv-as="CUI / CNP"
                data-vv-name="vat_no"
            />
            <v-text-field
                v-model="autocomplete.vModel.trade_registry_no"
                :disabled="true"
                class="primary--text"
                name="trade_registry_no"
                label="Numarul Registrul Comertului"
                data-vv-as="Numarul Registrul Comertului"
                data-vv-name="trade_registry_no"
            />
            <v-text-field
                v-model="autocomplete.vModel.bank"
                :disabled="true"
                class="primary--text"
                name="bank"
                label="Banca"
                data-vv-as="Banca"
                data-vv-name="bank"
            />
            <v-text-field
                v-model="autocomplete.vModel.iban"
                :disabled="true"
                class="primary--text"
                name="iban"
                label="IBAN"
                data-vv-as="IBAN"
                data-vv-name="iban"
            />
            <v-divider
                class="mx-4"
                vertical
            ></v-divider>
            <v-subheader>
                Sediu social
            </v-subheader>

            <v-text-field
                v-model="autocomplete.vModel.country"
                :disabled="true"
                class="primary--text"
                name="country"
                label="Tara"
                data-vv-as="Tara"
                data-vv-name="country"
            />

            <v-text-field
                v-model="autocomplete.vModel.county"
                :disabled="true"
                class="primary--text"
                name="county"
                label="Judet"
                data-vv-as="Judet"
                data-vv-name="county"
            />

            <v-text-field
                v-model="autocomplete.vModel.city"
                :disabled="true"
                class="primary--text"
                name="city"
                label="Localitate"
                data-vv-as="Localitate"
                data-vv-name="city"
            />
            <v-text-field
                v-model="autocomplete.vModel.address"
                :disabled="true"
                class="primary--text"
                name="address"
                label="Strada"
                data-vv-as="Strada"
                data-vv-name="address"
            />

            <v-divider
                class="mx-4"
                vertical
            ></v-divider>
            <v-subheader>
                Alte informatii
            </v-subheader>
            <v-text-field
                v-model="autocomplete.vModel.phone"
                :disabled="true"
                class="primary--text"
                name="phone"
                label="Telefon"
                data-vv-as="Telefon"
                data-vv-name="phone"
            />
            <v-text-field
                v-model="autocomplete.vModel.contact_phone"
                :disabled="true"
                class="primary--text"
                name="contact_phone"
                label="Telefon contact"
                data-vv-as="Telefon contact"
                data-vv-name="contact_phone"
            />
            <v-text-field
                v-model="autocomplete.vModel.email"
                :disabled="true"
                class="primary--text"
                name="email"
                label="E-mail"
                data-vv-as="E-mail"
                data-vv-name="email"
            />
            <v-text-field
                v-model="autocomplete.vModel.data.contact_person"
                :disabled="true"
                class="primary--text"
                name="data.contact_person"
                label="Persoana de contact"
                data-vv-as="Persoana de contact"
                data-vv-name="data.contact_person"
            />
            <v-text-field
                v-model="autocomplete.vModel.data.due_days"
                :disabled="true"
                class="primary--text"
                name="data.due_days"
                label="Zile scadenta"
                data-vv-as="Zile scadenta"
                data-vv-name="data.due_days"
            />
            <v-textarea
                v-model="autocomplete.vModel.data.remarks"
                :disabled="true"
                class="primary--text"
                name="remarks"
                label="Observatii"
                data-vv-as="Observatii"
                data-vv-name="remarks"
            />
        </template>
        <template v-if="showOrdersSummary && ordersSummary.length">
            <v-alert
                dense
                border="left"
                type="warning"
            >
                Clientul are {{ ordersSummary.length }} {{ ordersSummary.length > 1 ? 'solicitari de oferte' : 'solicitare de oferta' }} din ultimele 72 de ore.
            </v-alert>
        </template>
        <v-dialog v-model="dialog" width="70vw">
            <v-card>
                <v-card-title>
                    Adaugare client
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    v-model="form.name"
                                    v-validate="'required'"
                                    :error-messages="errorMessages('name')"
                                    :class="{ 'error--text': hasErrors('name') }"
                                    class="primary--text"
                                    name="name"
                                    label="Denumire"
                                    data-vv-as="Denumire"
                                    data-vv-name="name"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.vat_no"
                                    v-validate="'required'"
                                    :error-messages="errorMessages('vat_no')"
                                    :class="{ 'error--text': hasErrors('vat_no') }"
                                    class="primary--text"
                                    name="vat_no"
                                    label="CUI / CNP"
                                    data-vv-as="CUI / CNP"
                                    data-vv-name="vat_no"
                                    counter="255"
                                >
                                    <template v-slot:append-outer>
                                        <v-btn
                                            class="mx-2"
                                            fab
                                            dark
                                            x-small
                                            color="primary"
                                            @click="searchVatAndFillValues"
                                        >
                                            <v-icon dark>
                                                mdi-magnify
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                                <v-text-field
                                    v-model="form.trade_registry_no"
                                    :error-messages="errorMessages('trade_registry_no')"
                                    :class="{ 'error--text': hasErrors('trade_registry_no') }"
                                    class="primary--text"
                                    name="trade_registry_no"
                                    label="Numarul Registrul Comertului"
                                    data-vv-as="Numarul Registrul Comertului"
                                    data-vv-name="trade_registry_no"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.bank"
                                    :error-messages="errorMessages('bank')"
                                    :class="{ 'error--text': hasErrors('bank') }"
                                    class="primary--text"
                                    name="bank"
                                    label="Banca"
                                    data-vv-as="Banca"
                                    data-vv-name="bank"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.iban"
                                    :error-messages="errorMessages('iban')"
                                    :class="{ 'error--text': hasErrors('iban') }"
                                    class="primary--text"
                                    name="iban"
                                    label="IBAN"
                                    data-vv-as="IBAN"
                                    data-vv-name="iban"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.country"
                                    v-validate="'required'"
                                    :error-messages="errorMessages('country')"
                                    :class="{ 'error--text': hasErrors('country') }"
                                    class="primary--text"
                                    name="country"
                                    label="Tara"
                                    data-vv-as="Tara"
                                    data-vv-name="country"
                                />

                                <v-text-field
                                    v-model="form.county"
                                    v-validate="'required'"
                                    :error-messages="errorMessages('county')"
                                    :class="{ 'error--text': hasErrors('county') }"
                                    class="primary--text"
                                    name="county"
                                    label="Judet"
                                    data-vv-as="Judet"
                                    data-vv-name="county"
                                />
                                <v-text-field
                                    v-model="form.city"
                                    v-validate="'required'"
                                    :error-messages="errorMessages('city')"
                                    :class="{ 'error--text': hasErrors('city') }"
                                    class="primary--text"
                                    name="city"
                                    label="Localitate"
                                    data-vv-as="Localitate"
                                    data-vv-name="city"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.address"
                                    v-validate="'required'"
                                    :error-messages="errorMessages('address')"
                                    :class="{ 'error--text': hasErrors('address') }"
                                    class="primary--text"
                                    name="address"
                                    label="Strada"
                                    data-vv-as="Strada"
                                    data-vv-name="address"
                                    counter="255"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    v-model="form.phone"
                                    :error-messages="errorMessages('phone')"
                                    :class="{ 'error--text': hasErrors('phone') }"
                                    class="primary--text"
                                    name="phone"
                                    label="Telefon"
                                    data-vv-as="Telefon"
                                    data-vv-name="phone"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.contact_phone"
                                    :error-messages="errorMessages('contact_phone')"
                                    :class="{ 'error--text': hasErrors('contact_phone') }"
                                    class="primary--text"
                                    name="contact_phone"
                                    label="Telefon contact"
                                    data-vv-as="Telefon contact"
                                    data-vv-name="contact_phone"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.email"
                                    v-validate="'email'"
                                    :error-messages="errorMessages('email')"
                                    :class="{ 'error--text': hasErrors('email') }"
                                    class="primary--text"
                                    name="email"
                                    label="E-mail"
                                    data-vv-as="E-mail"
                                    data-vv-name="email"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.data.contact_person"
                                    :error-messages="errorMessages('data.contact_person')"
                                    :class="{ 'error--text': hasErrors('data.contact_person') }"
                                    class="primary--text"
                                    name="data.contact_person"
                                    label="Persoana de contact"
                                    data-vv-as="Persoana de contact"
                                    data-vv-name="data.contact_person"
                                    counter="255"
                                />
                                <v-text-field
                                    v-model="form.data.due_days"
                                    v-validate="'numeric'"
                                    :error-messages="errorMessages('data.due_days')"
                                    :class="{ 'error--text': hasErrors('data.due_days') }"
                                    class="primary--text"
                                    name="data.due_days"
                                    label="Zile scadenta"
                                    data-vv-as="Zile scadenta"
                                    data-vv-name="data.due_days"
                                />
                                <v-textarea
                                    v-model="form.data.remarks"
                                    :error-messages="errorMessages('remarks')"
                                    :class="{ 'error--text': hasErrors('remarks') }"
                                    class="primary--text"
                                    name="remarks"
                                    label="Observatii"
                                    data-vv-as="Observatii"
                                    data-vv-name="remarks"
                                    counter="255"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider/>

                <v-card-actions>
                    <v-btn
                        color="secondary"
                        @click="closeDialog">
                        <v-icon left>arrow_left</v-icon>
                        Anulare
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        color="primary"
                        @click="submit">Salveaza
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import validationError from "Mixins/validation-error";
import openAPI from "Mixins/openapi";
import {Form} from "vform";
import throttle from 'lodash/throttle'

export default {
    mixins: [validationError, openAPI],
    props: {
        value: {
            type: [Object, Number],
            default() {
                return null
            }
        },
        initialItems: {
            type: Array,
            default() {
                return []
            }
        },
        inline: {
            type: Boolean,
            default() {
                return false
            }
        },
        expandeable: {
            type: Boolean,
            default() {
                return false
            }
        },
        fieldErrors: {
            type: Array,
            default() {
                return []
            }
        },
        returnObject: {
            type: Boolean,
            default() {
                return false
            }
        },
        showSummary: {
            type: Boolean,
            default() {
                return false
            }
        },
        showOrdersSummary: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data () {
        return {
            loading: true,
            dialog: false,
            expand: false,
            autocomplete: {
                vModel: {
                    id: null,
                    name: null,
                    phone: null,
                    contact_phone: null,
                    email: null,
                    trade_registry_no: null,
                    vat_no: null,
                    bank: null,
                    iban: null,
                    country: 'Romania',
                    county: null,
                    city: null,
                    address: null,
                    data: {
                        due_days: null,
                        contact_person: null,
                        remarks: null
                    },
                    summary: {
                        emails: [],
                        phones: []
                    }
                },
                items: this.initialItems.filter(item => !_.isNil(item?.id)),
                isLoading: false,
                search: null,
            },
            form: new Form({
                id: null,
                name: null,
                phone: null,
                contact_phone: null,
                email: null,
                trade_registry_no: null,
                vat_no: null,
                bank: null,
                iban: null,
                country: 'Romania',
                county: null,
                city: null,
                address: null,
                data: {
                    due_days: null,
                    contact_person: null,
                    remarks: null
                },
                summary: {
                    emails: [],
                    phones: []
                }
            }),
            ordersSummary: []
        }
    },
    watch: {
        value: {
            handler(val) {
                this.handleValueChange(val)
            },
            deep: true
        },
        'autocomplete.vModel': {
            handler(val) {
                this.$emit('input', this.returnObject ? val : val?.id)
                this.$emit('change', val)
                if (this.showOrdersSummary && val?.id !== undefined) {
                    this.$db.Offer
                        .where('customer_id', val.id)
                        .where('between', [window.moment().subtract(72, 'hour').toISOString(), window.moment().toISOString()].join(','))
                        .get()
                        .then(({data}) => {
                            this.ordersSummary = data
                        })
                }
            },
            deep: true
        },
        'autocomplete.search': {
            handler: throttle(async function (val) {
                var self = this
                if (this.autocomplete.isLoading || this.loading || this._.isNil(val) || (val instanceof String && val.length < 3)) return
                this.autocomplete.isLoading = true
                var query = this.$db.Customer
                    .where('autocomplete', val)
                if (this.showSummary) {
                    query = query.append('summary')
                }

                await query.get()
                    .then(({data}) => {
                        self.autocomplete.items = data
                    })
                    .finally(() => {
                        self.autocomplete.isLoading = false
                    })
            }, 500),
        }
    },
    mounted() {
        this.handleValueChange(this.value)
        this.loading = false
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        handleValueChange: throttle(async function (val) {
            if(!this._.isEqual(val, this.autocomplete.vModel)) {
                if(!this._.isNil(val)) {
                    if(val instanceof Object) {
                        this.autocomplete.items.push(val)
                        this.autocomplete.vModel = val
                    } else if (parseInt(val) > 0 && this.autocomplete.items.indexOf(val) < 0) {
                        var query = this.$db.Customer
                        if (this.showSummary) {
                            query = query.append('summary')
                        }
                        query.find(val).then(({data}) => {
                            this.autocomplete.vModel = data
                            this.autocomplete.items.push(data)
                        })
                    }
                } else {
                    this.resetForm()
                }
            }
        }, 500),
        async submit() {
            let self = this;
            this.$validator.validateAll().then(result => {
                if (result) {
                    // eslint-disable-next-line
                    self.createOrUpdate();
                } else {
                    this.showError()
                }
            });
        },
        async createOrUpdate() {
            let self = this;
            self.form.busy = true;

            var model = new this.$db.Customer(self.form);
            if (this.id) {
                model.id = this.id
            }

            model.save()
                .then(response => {
                    self.$validator.reset();
                    this.showSuccess();
                    self.$nextTick(() => {
                        self.autocomplete.vModel = Object.assign({}, response)
                        self.autocomplete.items.push(self.autocomplete.vModel)
                        self.dialog = false
                        self.resetForm()
                    });
                })
                .catch(errors => {
                    self.form.errors.set(this.form.extractErrors(errors.response))
                    this.showError()
                }).finally(() => {
                self.form.busy = false;
            });
        },
        async searchVatAndFillValues() {
            await this.searchVatNo(this.form.vat_no)
                .then(({data}) => {
                    var splicedAddress = this._.get(data, 'adresa', '').split(',')
                    var city = splicedAddress.pop()
                    var address = splicedAddress.join(',')
                    var vatNo = !this._.isNil(data?.tva) ? `RO${data.cif}` : data?.cif
                    this.form = new Form(Object.assign(this.form, {
                        name: data?.denumire,
                        phone: data?.telefon,
                        trade_registry_no: data?.numar_reg_com,
                        vat_no: vatNo,
                        country: 'Romania',
                        county: data?.judet,
                        city: city,
                        address: address
                    }))
                })
        },
        resetForm() {
            this.form = new Form({
                id: null,
                name: null,
                phone: null,
                contact_phone: null,
                email: null,
                trade_registry_no: null,
                vat_no: null,
                bank: null,
                iban: null,
                country: 'Romania',
                county: null,
                city: null,
                address: null,
                data: {
                    due_days: null,
                    contact_person: null,
                    remarks: null
                },
                summary: {
                    emails: [],
                    phones: []
                },
            })
        }
    }
};
</script>
